(function () {
    function initUpsellTabs(root) {
      if (!root || root.__upsellTabsInit) return;
      root.__upsellTabsInit = true;
      var headers = Array.prototype.slice.call(root.querySelectorAll("[js-upsell-tab-header]"));
      var contents = Array.prototype.slice.call(root.querySelectorAll("[js-upsell-tab-content]"));
      if (!headers.length || !contents.length) return;
      function activate(handle) {
        if (!handle) return;
        headers.forEach(function (h) {
          h.classList.toggle("selected", h.getAttribute("data-upsell-handle") === handle);
        });
        contents.forEach(function (c) {
          c.classList.toggle("is-active", c.getAttribute("data-upsell-handle") === handle);
        });
      }
      var defaultHeader = headers.find(function (h) { return h.classList.contains("selected"); }) || headers[0];
      activate(defaultHeader.getAttribute("data-upsell-handle"));
      headers.forEach(function (header) {
        header.addEventListener("click", function () {
          activate(header.getAttribute("data-upsell-handle"));
        });
      });
    }
    function initAll() {
      document.querySelectorAll("[js-product-upsell]").forEach(function (root) {
        initUpsellTabs(root);
      });
    }
    document.addEventListener("DOMContentLoaded", initAll);
    document.addEventListener("shopify:section:load", function (e) {
      if (!e || !e.target) return;
      e.target.querySelectorAll("[js-product-upsell]").forEach(function (root) {
        initUpsellTabs(root);
      });
    });

    document.querySelectorAll('[js-upsell-product-close-btn]').forEach(closeBtn => {
        closeBtn.addEventListener('click', () => {
            closeBtn.closest('[js-product-upsell-widget]')?.classList.remove('active');
            document.querySelector('cart-drawer')?.show();
        })
    })
  })();